import { TextField, MuiThemeProvider } from '@material-ui/core'
import FeatherIcon from 'feather-icons-react'
import { getRowId, getRowIndex } from './index'
import {
  getDataValue,
  renderActive,
  renderCheckbox,
  renderCurrency,
  renderDate,
  renderDateTime,
  renderImage,
  renderMediaId,
  renderOrderNumber,
  renderSelect,
  renderStatus,
  renderString,
  renderLabel,
  renderTime,
  renderHtml,
  renderArrayToString,
  renderMultiField,
  renderAutocomplete,
  renderCalculate,
  renderUser,
  renderNumeric,
} from '../Render'
import renderButton from '../render/Button'
import CustomSelect from '../render/Select'
import CustomAutocomplete from '../render/Autocomplete'
import CustomDate from '../render/Date'
import CustomTime from '../render/Time'
import CustomDateTime from '../render/DateTime'
import CustomCheckbox from '../render/Checkbox'
import CustomUser from '../render/User'
import objectPath from 'object-path'
import {
  compareTwoValue,
  formatNumber,
  isNumber,
  truncateDecimal,
} from 'designer/component/action/Data'
import { Button, Form, InputGroup } from 'react-bootstrap'
import { isEmpty } from 'designer/component/action/condition/State'
import {
  deleteData,
  getData,
  mapResponseData,
  patchData,
  postData,
  putData,
} from 'designer/component/action/Api'
import { onCheckCondition } from 'designer/component/action/condition/Action'
import { getAllApi } from 'designer/component/action/Option'
import NumberFormat from 'react-number-format'
import FreeTextSearch from '../render/FreeTextSearch'
import CustomAutocompleteSearch from '../render/CustomAutocomplete'
import { debounceCallback } from 'utility/debounceCallback.util'

const getAutoFocus = (focus, field, rowData, isRenderColumn) => {
  if (isRenderColumn) {
    return {
      autoFocus:
        focus?.rowData?.tableData?.id === rowData?.tableData?.id &&
        focus?.column === field,
    }
  }
  return {}
}

const onCellChange = ({
  editProps,
  rowIndex,
  field,
  value,
  props,
  checkCallApi = true,
}) => {
  let { stateParent, defaultProp } = props
  let { tableData, setTableData, setFocus } = stateParent
  let tableColumn = props?.defaultProp?.uischema?.tableColumn || []
  let rowData = editProps?.rowData || editProps
  let filterTableDefault = tableColumn.filter((column) => column.defaultValue)
  filterTableDefault.forEach((column) => {
    let { field, defaultValue } = column
    let hasValue = objectPath.has(rowData, field)
    if (!hasValue) {
      objectPath.set(rowData, field, defaultValue)
    }
  })
  if (editProps?.onRowDataChange) {
    objectPath.set(rowData, field, value)
    editProps.onRowDataChange(rowData)
  } else {
    setFocus({ rowData: editProps, column: field })
    objectPath.set(tableData, `${rowIndex}.${field}`, value)
    setTableData(tableData)
  }

  let isFavoriteModal = objectPath.get(defaultProp, 'isFavoriteModal')
  let shouldCheckCallApi = checkCallApi === true
  if (!isFavoriteModal && defaultProp?.designContext && shouldCheckCallApi) {
    let {
      uischema: tableUi,
      column,
      designContext,
      formData,
      allParams = {},
    } = defaultProp
    let {
      jsonForm,
      isUiChanged,
      setIsUiChanged,
      setFormData,
      setDatasourceValue,
    } = designContext
    let rowUpdate = editProps?.onRowDataChange
      ? rowData
      : objectPath.get(tableData, rowIndex) ?? rowData
    let apiOptions = getAllApi(jsonForm)
    let datasourceValue = objectPath.get(designContext, '@datasource')
    debounceCallback(
      checkCallApiCondition,
      [
        {
          uischema: column,
          rowUpdate,
          apiOptions,
          formData: formData ?? jsonForm?.formData,
          allParams,
          datasourceValue,
          designContext,
          jsonForm,
          tableUi,
          setFormData,
          isUiChanged,
          setIsUiChanged,
          setDatasourceValue,
        },
      ],
      'check-call-api-condition',
    )
  }
}

const handleKeyDown = (e, rowData, props) => {
  let { stateParent } = props
  let { columnRequire } = stateParent
  let emptyValue = columnRequire.filter((requireKey) => {
    let value = objectPath.has(rowData, requireKey)
      ? objectPath.has(rowData, requireKey)
      : undefined
    return isEmpty(value)
  })
  if (emptyValue.length > 0 && e.key === 'Enter') {
    e.preventDefault()
    e.stopPropagation()
  }
}

export const checkLockMode = (column = {}, rowData) => {
  let { isLockAdd, isLockUpdate, isLockEdit, conditions } = column
  const isUpdateMode = rowData?.tableData?.id !== undefined
  const isAddMode = !isUpdateMode
  let isLocked
  if (conditions && conditions.length > 0) {
    conditions.forEach((condition) => {
      let {
        value,
        valueType = 'equalValue',
        conditionField,
        actionColumn,
      } = condition
      let field = conditionField ?? column.field
      let rowValue = objectPath.get(rowData, field)
      let passValue = compareTwoValue(valueType, rowValue, value)
      let isLockAdd = actionColumn === 'lockAdd'
      let isLockUpdate = actionColumn === 'lockUpdate'
      let isLockAll = actionColumn === 'lockAll'
      let isLockColumn =
        isLockAll || (isAddMode && isLockAdd) || (isUpdateMode && isLockUpdate)
      if (passValue && isLockColumn) {
        isLocked = true
      }
    })
  } else {
    isLocked =
      isLockEdit || (isAddMode && isLockAdd) || (isUpdateMode && isLockUpdate)
  }
  return isLocked
}

export const checkCallApiCondition = async ({
  uischema,
  rowUpdate,
  apiOptions,
  formData,
  allParams,
  datasourceValue,
  designContext,
  jsonForm,
  tableUi,
  setFormData,
  isUiChanged,
  setIsUiChanged,
  setDatasourceValue,
}) => {
  let conditions = uischema?.conditions
  let foundCondition = conditions?.filter((condition) => {
    let { conditionField, callApi } = condition
    let hasValue = objectPath.get(rowUpdate, conditionField)
    return hasValue && callApi
  })
  if (foundCondition?.length > 0) {
    foundCondition.forEach(async (condition) => {
      let { callApi } = condition
      let api = apiOptions.find((api) => api.key === callApi)
      let data = {
        formData: formData,
        allParams: allParams,
        datasourceValue: datasourceValue,
      }
      let response
      if (api.method === 'get') {
        response = await getData(api, data, designContext, true)
      } else if (api.method === 'post') {
        response = await postData(api, data, designContext)
      } else if (api.method === 'put') {
        response = await putData(api, data, designContext)
      } else if (api.method === 'patch') {
        response = await patchData(api, data, designContext)
      } else if (api.method === 'delete') {
        response = await deleteData(api, data, designContext)
      }

      if (response) {
        let responseData = response?.data || {}
        let newFormData = mapResponseData(
          api,
          responseData,
          formData,
          false,
          jsonForm,
          designContext,
        )
        objectPath.set(newFormData, `@response.${api.key}`, responseData)
        if (api.dataKey) {
          let data = objectPath.get(responseData, api.dataKey)
          objectPath.set(datasourceValue, api.key, data)
          setDatasourceValue(datasourceValue)
        } else {
          objectPath.set(datasourceValue, api.key, responseData)
          setDatasourceValue(datasourceValue)
        }
        onCheckCondition(designContext, formData, null, {
          apiKey: api.key,
          response: { [api.key]: responseData },
          isCheckOnlyResponse: true,
        })
        let newTableData = objectPath.get(newFormData, tableUi.key)
        setFormData(newFormData)
        objectPath.set(
          isUiChanged,
          [`isRenderTable`, tableUi.key],
          newTableData,
        )
        setIsUiChanged(isUiChanged)
      }
    })
  }
}

export const getEditComponent = (props, isRenderColumn) => {
  let { defaultProp, stateParent, actionProp } = props
  let { uischema, column, focus, tableRef } = defaultProp
  let { tableData } = stateParent
  let { onOpenModalTable } = actionProp

  switch (column.typeField ?? column.type) {
    case 'no':
      return (editProps) => {
        let rowData = editProps?.rowData || editProps
        return rowData?.tableData?.no || rowData?.['@seq']
      }

    case 'label':
      return (editProps) => {
        let rowData = editProps?.rowData || editProps
        let value = getDataValue(column, rowData)
        return value || ''
      }
    case 'string':
      return (editProps) => {
        let { field, isTextarea } = column
        let rowData = editProps?.rowData || editProps
        let id = getRowId(rowData, uischema)
        let rowIndex = getRowIndex(tableData, id, uischema)
        let fieldKey = `${field}-${id}`
        let value = getDataValue(column, rowData)
        let autoFocus = getAutoFocus(focus, field, rowData, isRenderColumn)
        let isLockEdit = checkLockMode(column, rowData)
        if (isLockEdit) {
          return value || ''
        }
        return (
          <TextField
            {...editProps}
            {...autoFocus}
            multiline={isTextarea}
            id={fieldKey}
            name={field}
            type="text"
            onChange={(e) => {
              let value = e.target.value
              onCellChange({ editProps, rowIndex, field, value, props })
            }}
            value={value || ''}
            error={editProps.error}
            onKeyDown={(e) => handleKeyDown(e, rowData, props)}
          />
        )
      }
    case 'arrayToString':
      return (editProps) => {
        let rowData = editProps?.rowData || editProps
        return renderArrayToString(defaultProp)(rowData)
      }
    case 'multiField':
      return (editProps) => {
        let rowData = editProps?.rowData || editProps
        return renderMultiField(defaultProp)(rowData)
      }
    case 'numeric':
      return (editProps) => {
        let {
          field,
          minValue = '',
          maxValue = '',
          thousandSeparator,
          precision = 0,
        } = column
        let rowData = editProps?.rowData || editProps

        let id = getRowId(rowData, uischema)
        let rowIndex = getRowIndex(tableData, id, uischema)
        let fieldKey = `${field}-${id}`
        let value = getDataValue(column, rowData) ?? 0
        let autoFocus = getAutoFocus(focus, field, rowData, isRenderColumn)
        let isWarningValue = false
        let warningValueText = ''
        if (minValue !== '') {
          if (value < minValue) {
            isWarningValue = true
            warningValueText = 'กรุณากรอกค่าอย่างน้อย ' + minValue
          }
        }
        if (maxValue !== '') {
          if (value > maxValue) {
            isWarningValue = true
            warningValueText = 'กรุณากรอกค่าไม่เกิน ' + maxValue
          }
        }
        let isLockEdit = checkLockMode(column, rowData)
        if (isLockEdit) {
          let format = thousandSeparator
            ? formatNumber(value, precision)
            : truncateDecimal(value, precision, true)
          return format.toString()
        }
        return (
          <>
            <NumberFormat
              {...editProps}
              {...autoFocus}
              id={fieldKey}
              name={field}
              style={{ textAlign: column?.textAlign || 'left' }}
              className="form-control"
              thousandSeparator={thousandSeparator}
              autoComplete="off"
              value={value}
              defaultValue={0}
              onChange={(e) => {
                let stringValue = e.target.value
                let value = stringValue.replace(',', '')
                onCellChange({ editProps, rowIndex, field, value, props })
              }}
              onKeyDown={(e) => handleKeyDown(e, rowData, props)}
            />
            {isWarningValue && warningValueText && (
              <Form.Label className="text-danger mb-0 pr-1">
                {warningValueText}
              </Form.Label>
            )}
          </>
        )
      }
    case 'currency':
      return (editProps) => {
        let { field, minValue = '', maxValue = '', thousandSeparator } = column
        let rowData = editProps?.rowData || editProps
        let id = getRowId(rowData, uischema)
        let rowIndex = getRowIndex(tableData, id, uischema)
        let fieldKey = `${field}-${id}`
        let value = getDataValue(column, rowData)
        let autoFocus = getAutoFocus(focus, field, rowData, isRenderColumn)
        let currency = objectPath.get(column, 'currency.prefix')
        let isWarningValue = false
        let warningValueText = ''
        if (minValue !== '') {
          if (value < minValue) {
            isWarningValue = true
            warningValueText = 'กรุณากรอกค่าอย่างน้อย ' + minValue
          }
        }
        if (maxValue !== '') {
          if (value > maxValue) {
            isWarningValue = true
            warningValueText = 'กรุณากรอกค่าไม่เกิน ' + maxValue
          }
        }
        let isLockEdit = checkLockMode(column, rowData)
        if (isLockEdit) {
          return value || ''
        }
        return (
          <>
            <InputGroup style={{ flexWrap: 'unset' }}>
              {currency && (
                <InputGroup.Text
                  className={`px-2 text-secondary bg-white`}
                  style={{
                    cursor: 'default',
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderRight: 0,
                  }}
                >
                  <span className="px-1">{'$'}</span>
                </InputGroup.Text>
              )}
              <NumberFormat
                {...editProps}
                {...autoFocus}
                id={fieldKey}
                name={field}
                style={{ textAlign: column?.textAlign || 'left' }}
                className="form-control"
                thousandSeparator={thousandSeparator}
                autoComplete="off"
                value={value}
                defaultValue={0}
                onChange={(e) => {
                  let stringValue = e.target.value
                  let value = stringValue.replace(',', '')
                  onCellChange({ editProps, rowIndex, field, value, props })
                }}
                onKeyDown={(e) => handleKeyDown(e, rowData, props)}
              />
            </InputGroup>
            {isWarningValue && warningValueText && (
              <Form.Label className="text-danger mb-0 pr-1">
                {warningValueText}
              </Form.Label>
            )}
          </>
        )
      }
    case 'select':
      return (editProps) => {
        let ui = column
        let { field, mapOther } = column
        let rowData = editProps?.rowData || editProps
        let id = getRowId(rowData, uischema)
        let fieldKey = `${field}-${id}`
        let value = objectPath.get(rowData, field)

        const onUpdateRowData = (rowData) => {
          let value = objectPath.get(rowData, field)
          let rowIndex = getRowIndex(tableData, id, uischema)
          onCellChange({ editProps, rowIndex, field, value, props })
        }
        let isLockEdit = checkLockMode(column, rowData)
        if (isLockEdit) {
          return value || ''
        }
        return (
          <CustomSelect
            {...editProps}
            fieldKey={fieldKey}
            fieldName={field}
            ui={ui}
            onUpdateRowData={onUpdateRowData}
            dataTable={tableData}
            handleKeyDown={(e, rowData) => handleKeyDown(e, rowData, props)}
            column={column}
          />
        )
      }
    case 'autocomplete':
      return (editProps) => {
        let ui = column
        let rowData = editProps?.rowData || editProps
        let { field, altModal } = column
        let id = getRowId(rowData, uischema)
        let fieldKey = `${field}-${id}`
        let value = objectPath.get(rowData, field)
        const buttonColor = altModal?.buttonColor
        const initialColor = buttonColor ?? '#4099ff'

        const onUpdateRowData = (rowData) => {
          let value = objectPath.get(rowData, field)
          let rowIndex = getRowIndex(tableData, id, uischema)
          onCellChange({ editProps, rowIndex, field, value, props })
        }
        let isLockEdit = checkLockMode(column, rowData)
        if (isLockEdit) {
          return value || ''
        }
        return (
          <div className="d-flex">
            <CustomAutocomplete
              {...editProps}
              fieldKey={fieldKey}
              fieldName={field}
              ui={ui}
              value={value}
              onUpdateRowData={onUpdateRowData}
              tableRef={tableRef}
              tableColumn={uischema.tableColumn}
              handleKeyDown={(e, rowData) => handleKeyDown(e, rowData, props)}
              column={column}
            />
            {altModal?.formCode && (
              <Button
                className="px-2 py-1 ml-2"
                style={{
                  color: initialColor,
                  borderColor: buttonColor ? initialColor : 'transparent',
                  backgroundColor: 'transparent',
                }}
                onClick={() => onOpenModalTable(rowData, column, altModal)}
              >
                <FeatherIcon icon="plus" size="14" variant="outline-primary" />
              </Button>
            )}
          </div>
        )
      }
    case 'freeTextSearch':
      return (editProps) => {
        let ui = column
        let rowData = editProps?.rowData || editProps
        let { field, altModal } = column
        let id = getRowId(rowData, uischema)
        let fieldKey = `${field}-${id}`
        let value = objectPath.get(rowData, field)
        const buttonColor = altModal?.buttonColor
        const initialColor = buttonColor ?? '#4099ff'
        let { tagname } = uischema

        const onUpdateRowData = (rowData, options = {}) => {
          let value = objectPath.get(rowData, field)
          let rowIndex = getRowIndex(tableData, id, uischema)
          onCellChange({
            editProps,
            rowIndex,
            field,
            value,
            props,
            checkCallApi: options.checkCallApi,
          })
        }
        let isLockEdit = checkLockMode(column, rowData)
        if (isLockEdit) {
          return value || ''
        }

        if (tagname === 'customTable') {
          return (
            <div className="d-flex">
              <CustomAutocompleteSearch
                {...props}
                {...editProps}
                fieldKey={fieldKey}
                fieldName={field}
                ui={ui}
                uischema={uischema}
                value={value}
                onUpdateRowData={onUpdateRowData}
                tableRef={tableRef}
                tableColumn={uischema.tableColumn}
                handleKeyDown={(e, rowData) => handleKeyDown(e, rowData, props)}
                column={column}
                tableUi={uischema}
              />
              {altModal?.formCode && (
                <Button
                  className="px-2 py-1 ml-2"
                  style={{
                    color: initialColor,
                    borderColor: buttonColor ? initialColor : 'transparent',
                    backgroundColor: 'transparent',
                  }}
                  onClick={() => onOpenModalTable(rowData, column, altModal)}
                >
                  <FeatherIcon
                    icon="plus"
                    size="14"
                    variant="outline-primary"
                  />
                </Button>
              )}
            </div>
          )
        }
        return (
          <div className="d-flex">
            <FreeTextSearch
              {...editProps}
              fieldKey={fieldKey}
              fieldName={field}
              ui={ui}
              value={value}
              onUpdateRowData={onUpdateRowData}
              tableRef={tableRef}
              tableColumn={uischema.tableColumn}
              handleKeyDown={(e, rowData) => handleKeyDown(e, rowData, props)}
              column={column}
            />
            {altModal?.formCode && (
              <Button
                className="px-2 py-1 ml-2"
                style={{
                  color: initialColor,
                  borderColor: buttonColor ? initialColor : 'transparent',
                  backgroundColor: 'transparent',
                }}
                onClick={() => onOpenModalTable(rowData, column, altModal)}
              >
                <FeatherIcon icon="plus" size="14" variant="outline-primary" />
              </Button>
            )}
          </div>
        )
      }
    case 'date':
      return (editProps) => {
        let ui = column
        let rowData = editProps?.rowData || editProps
        let { field } = column
        let id = getRowId(rowData, uischema)
        let fieldKey = `${field}-${id}`

        const onUpdateRowData = (rowData) => {
          let value = objectPath.get(rowData, field)
          let rowIndex = getRowIndex(tableData, id, uischema)
          onCellChange({ editProps, rowIndex, field, value, props })
        }

        return (
          <CustomDate
            {...editProps}
            id={fieldKey}
            name={field}
            ui={ui}
            onUpdateRowData={onUpdateRowData}
            handleKeyDown={(e, rowData) => handleKeyDown(e, rowData, props)}
            column={column}
            isTable={true}
          />
        )
      }
    case 'time':
      return (editProps) => {
        let ui = column
        let rowData = editProps?.rowData || editProps
        let { field } = column
        let id = getRowId(rowData, uischema)
        let fieldKey = `${field}-${id}`

        const onUpdateRowData = (rowData) => {
          let value = objectPath.get(rowData, field)
          let rowIndex = getRowIndex(tableData, id, uischema)
          onCellChange({ editProps, rowIndex, field, value, props })
        }

        return (
          <CustomTime
            {...editProps}
            id={fieldKey}
            name={field}
            uischema={ui}
            onUpdateRowData={onUpdateRowData}
            handleKeyDown={(e, rowData) => handleKeyDown(e, rowData, props)}
            column={column}
            isTable={true}
          />
        )
      }
    case 'datetime':
      return (editProps) => {
        let ui = column
        let rowData = editProps?.rowData || editProps
        let { field } = column
        let id = getRowId(rowData, uischema)
        let fieldKey = `${field}-${id}`

        const onUpdateRowData = (rowData) => {
          let value = objectPath.get(rowData, field)
          let rowIndex = getRowIndex(tableData, id, uischema)
          onCellChange({ editProps, rowIndex, field, value, props })
        }

        return (
          <CustomDateTime
            {...editProps}
            id={fieldKey}
            name={field}
            ui={ui}
            onUpdateRowData={onUpdateRowData}
            handleKeyDown={(e, rowData) => handleKeyDown(e, rowData, props)}
            column={column}
            isTable={true}
          />
        )
      }
    case 'boolean':
      return (editProps) => {
        let ui = column
        let rowData = editProps?.rowData || editProps
        let { field, isLockEdit } = column
        let id = getRowId(rowData, uischema)
        let fieldKey = `${field}-${id}`

        let valueChecked = objectPath.get(column, 'checkbox.checked')
        let valueUnChecked = objectPath.get(column, 'checkbox.unchecked')
        valueChecked = isNumber(valueChecked)
          ? Number(valueChecked)
          : valueChecked
        valueUnChecked = isNumber(valueUnChecked)
          ? Number(valueUnChecked)
          : valueUnChecked

        const onUpdateRowData = (rowData) => {
          let value = objectPath.get(rowData, field)
          let rowIndex = getRowIndex(tableData, id, uischema)
          onCellChange({ editProps, rowIndex, field, value, props })
        }

        return (
          <CustomCheckbox
            {...editProps}
            rowData={rowData}
            ui={ui}
            id={fieldKey}
            name={field}
            onUpdateRowData={onUpdateRowData}
            valueChecked={valueChecked}
            valueUnChecked={valueUnChecked}
            disabled={isLockEdit}
          />
        )
      }
    case 'checkbox':
      return (editProps) => {
        let ui = column
        let rowData = editProps?.rowData || editProps
        let { field, isLockEdit } = column
        let id = getRowId(rowData, uischema)
        let fieldKey = `${field}-${id}`

        let valueChecked = objectPath.get(column, 'checkbox.checked')
        let valueUnChecked = objectPath.get(column, 'checkbox.unchecked')
        valueChecked = isNumber(valueChecked)
          ? Number(valueChecked)
          : valueChecked
        valueUnChecked = isNumber(valueUnChecked)
          ? Number(valueUnChecked)
          : valueUnChecked

        const onUpdateRowData = (rowData) => {
          let value = objectPath.get(rowData, field)
          let rowIndex = getRowIndex(tableData, id, uischema)
          onCellChange({ editProps, rowIndex, field, value, props })
        }

        return (
          <CustomCheckbox
            {...editProps}
            rowData={rowData}
            ui={ui}
            id={fieldKey}
            name={field}
            onUpdateRowData={onUpdateRowData}
            valueChecked={valueChecked}
            valueUnChecked={valueUnChecked}
            disabled={isLockEdit}
          />
        )
      }
    case 'active':
      return (editProps) => {
        let ui = column
        let rowData = editProps?.rowData || editProps
        let { field } = column
        let id = getRowId(rowData, uischema)
        let fieldKey = `${field}-${id}`

        let valueChecked = objectPath.get(column, 'status.active')
        let valueUnChecked = objectPath.get(column, 'status.inactive')
        valueChecked = isNumber(valueChecked)
          ? Number(valueChecked)
          : valueChecked
        valueUnChecked = isNumber(valueUnChecked)
          ? Number(valueUnChecked)
          : valueUnChecked

        const onUpdateRowData = (rowData) => {
          let value = objectPath.get(rowData, field)
          let rowIndex = getRowIndex(tableData, id, uischema)
          onCellChange({ editProps, rowIndex, field, value, props })
        }

        return (
          <CustomCheckbox
            {...editProps}
            ui={ui}
            id={fieldKey}
            name={field}
            onUpdateRowData={onUpdateRowData}
            valueChecked={valueChecked}
            valueUnChecked={valueUnChecked}
          />
        )
      }
    case 'userId':
      return (editProps) => {
        let ui = column
        let { field } = column
        let rowData = editProps?.rowData || editProps
        let id = getRowId(rowData, uischema)
        let fieldKey = `${field}-${id}`
        let optionValue = column?.type || column?.typeField

        const onUpdateRowData = (rowData) => {
          let value = objectPath.get(rowData, field)
          let rowIndex = getRowIndex(tableData, id, uischema)
          onCellChange({ editProps, rowIndex, field, value, props })
        }

        return (
          <CustomUser
            {...editProps}
            fieldKey={fieldKey}
            fieldName={field}
            ui={ui}
            onUpdateRowData={onUpdateRowData}
            dataTable={tableData}
            optionValue={optionValue}
            isLockEdit={column.isLockEdit}
          />
        )
      }
    case 'employeeCode':
      return (editProps) => {
        let ui = column
        let { field } = column
        let rowData = editProps?.rowData || editProps
        let id = getRowId(rowData, uischema)
        let fieldKey = `${field}-${id}`
        let optionValue = column?.type || column?.typeField

        const onUpdateRowData = (rowData) => {
          let value = objectPath.get(rowData, field)
          let rowIndex = getRowIndex(tableData, id, uischema)
          onCellChange({ editProps, rowIndex, field, value, props })
        }

        return (
          <CustomUser
            {...editProps}
            fieldKey={fieldKey}
            fieldName={field}
            ui={ui}
            onUpdateRowData={onUpdateRowData}
            dataTable={tableData}
            optionValue={optionValue}
            isLockEdit={column.isLockEdit}
          />
        )
      }
    case 'button':
      return renderButton({
        ...defaultProp,
        ...actionProp,
        ...stateParent,
        column,
        isEditable: true,
      })
    case 'status':
      return renderStatus({ column, isEditable: true })
    case 'calculate':
      return (editProps) => {
        let { thousandSeparator, precision = 0 } = column
        let value = getDataValue(column, editProps.rowData)
        let format = thousandSeparator
          ? formatNumber(value, precision)
          : truncateDecimal(value, precision, true)
        return format.toString()
      }
    default:
      return (editProps) => {
        let ui = column
        let rowData = editProps?.rowData || editProps
        let { field } = column
        let id = getRowId(rowData, uischema)
        let fieldKey = `${field}-${id}`

        let value = getDataValue(column, editProps.rowData)

        const onUpdateRowData = (rowData) => {
          let value = objectPath.get(rowData, field)
          let rowIndex = getRowIndex(tableData, id, uischema)
          onCellChange({ editProps, rowIndex, field, value, props })
        }

        return (
          <TextField
            {...editProps}
            id={fieldKey}
            name={field}
            onChange={(e) => {
              let newRowData = editProps.rowData
              let key = column.field
              if (column.valueType === 'receive' && column.receiveData) {
                key = column.receiveData.replace(/({|})/g, '')
              }
              objectPath.set(newRowData, key, e.target.value)
              onUpdateRowData(newRowData)
            }}
            value={value}
            error={editProps.error}
          />
        )
      }
  }
}

export const getRenderColumn = (props, isReadOnly) => {
  let { defaultProp, dateTimeProp, actionProp, stateParent } = props
  let { column } = defaultProp
  let { formatDate, formatTime, formatDateTime } = dateTimeProp

  if (column?.isEditOnRow) {
    let isRenderColumn = true
    return getEditComponent(props, isRenderColumn)
  }
  switch (column.typeField ?? column.type) {
    case 'label':
      return renderLabel(defaultProp)
    case 'string':
      return renderString(defaultProp)
    case 'arrayToString':
      return renderArrayToString(defaultProp)
    case 'multiField':
      return renderMultiField(defaultProp)
    case 'numeric':
      return renderNumeric(defaultProp)
    case 'no':
      return renderOrderNumber(defaultProp)
    case 'currency':
      return renderCurrency(defaultProp)
    case 'date':
      return renderDate({ ...defaultProp, formatDate })
    case 'time':
      return renderTime({ ...defaultProp, formatTime })
    case 'datetime':
      return renderDateTime({ ...defaultProp, formatDateTime })
    case 'checkbox':
      return renderCheckbox(defaultProp)
    case 'boolean':
      return renderCheckbox(defaultProp)
    case 'active':
      return renderActive(defaultProp)
    case 'status':
      return renderStatus(defaultProp)
    case 'select':
      return renderSelect(defaultProp)
    case 'autocomplete':
      return renderAutocomplete(defaultProp)
    case 'freeTextSearch':
      return renderAutocomplete(defaultProp)
    case 'image':
      return renderImage(defaultProp)
    case 'mediaId':
      return renderMediaId(defaultProp)
    case 'button':
      return isReadOnly
        ? () => ''
        : renderButton({ ...defaultProp, ...actionProp, ...stateParent })
    case 'html':
      return renderHtml(defaultProp)
    case 'calculate':
      return renderCalculate(defaultProp)
    case 'userId':
      return renderUser(defaultProp)
    case 'employeeCode':
      return renderUser(defaultProp)
    default:
      return
  }
}
